export default "__VITE_ASSET__DaicDeCw__ 800w, __VITE_ASSET__BTZuPzfu__ 1280w, __VITE_ASSET__7ZyGwl63__ 1920w";